import React, { useEffect, useMemo, useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, { PaginationProvider } from 'react-bootstrap-table2-paginator';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import * as actions from '../../../_redux/program/programAction';
import * as uiHelpers from '../ProgramUIHelpers';
import { Modal } from 'react-bootstrap';

import {
    getHandlerTableChange,
    NoRecordsFoundMessage,
    PleaseWaitMessage,
} from '../../../../../../_metronic/_helpers';
import * as columnFormatters from './column-formatters';
import { Pagination } from '../../../../../../_metronic/_partials/controls';
import { useProgramUIContext } from '../ProgramUIContext';
import { toast } from 'react-toastify';
import { toastOption } from '../../../../../../_metronic/_helpers';
import { RoleChecker } from '../../../../../RoleChecker';


const ProgramTable = (props) => {
    // Program UI Context
    const programUIContext = useProgramUIContext();
    const programUIProps = useMemo(() => {
        return {
            queryParams: programUIContext.queryParams,
            setQueryParams: programUIContext.setQueryParams,
            openEditProgramPage: programUIContext.openEditProgramPage,
        };
    }, [programUIContext]);


    // Getting curret state of program list from store (Redux)
    const { currentState } = useSelector(
        (state) => ({ currentState: state.programs }),
        shallowEqual,
    );

    const { totalCount, entities, listLoading, error } = currentState;
    if (error) {
        toast.error(error, toastOption)
    }

    const [toDelete, setToDelete] = useState({})
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const dispatch = useDispatch();
    useEffect(() => {

        //Requset ke Branch Action
        dispatch(actions.fetchPrograms(programUIProps.queryParams));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [programUIProps.queryParams, dispatch]);

    const deleteProgram = () => {
        dispatch(actions.deleteProgram(toDelete)).then(response => {
            toast.success("Program Berhasil Di Delete", toastOption)
            handleClose()
            dispatch(actions.fetchPrograms(programUIProps.queryParams));
        }).catch(error => {
            toast.error(error.response.message, toastOption)
        })
    }
    const allowEdit = RoleChecker('Edit', 'program')
    const allowDelete = RoleChecker('Delete', 'program')

    // Table columns
    const columns = [
        // {
        //     dataField: 'uuid',
        //     text: 'uuid',
        //     sort: true,
        // },
        {
            dataField: 'name',
            text: 'Nama Program',
            sort: true,
            // sortCaret: sortCaret,
        },
        // {
        //     dataField: 'branch.name',
        //     text: 'Nama Cabang',
        //     sort: true,
        //     // sortCaret: sortCaret,
        // },
        {
            dataField: 'action',
            text: 'Actions',
            formatter: columnFormatters.ActionsColumnFormatter,
            formatExtraData: {
                openEditProgramPage: programUIProps.openEditProgramPage,
                openDeleteProgramPage: handleShow,
                setToDelete: setToDelete,
                allowEdit,
                allowDelete
            },
            classes: 'text-right pr-0',
            headerClasses: 'text-right pr-3',
            style: {
                minWidth: '100px',
            },
        },
    ];

    // Table pagination properties
    const paginationOptions = {
        custom: true,
        totalSize: totalCount,
        sizePerPageList: uiHelpers.sizePerPageList,
        sizePerPage: programUIProps.queryParams.pageSize,
        page: programUIProps.queryParams.pageNumber,
    };

    return (
        <>
            <PaginationProvider pagination={paginationFactory(paginationOptions)}>
                {({ paginationProps, paginationTableProps }) => {
                    return (
                        <Pagination
                            isLoading={listLoading}
                            paginationProps={paginationProps}
                        >
                            <BootstrapTable
                                wrapperClasses="table-responsive"
                                classes="table table-head-custom table-vertical-center overflow-hidden"
                                bootstrap4
                                bordered={false}
                                remote
                                keyField="uuid"
                                data={entities === null ? [] : entities}
                                columns={columns}
                                // defaultSorted={uiHelpers.defaultSorted}
                                onTableChange={getHandlerTableChange(
                                    programUIProps.setQueryParams,
                                )}
                                // selectRow={getSelectRow({
                                //   entities,
                                //   ids: productsUIProps.ids,
                                //   setIds: productsUIProps.setIds,
                                // })}
                                {...paginationTableProps}
                            >
                                <PleaseWaitMessage entities={entities} />
                                <NoRecordsFoundMessage entities={entities} />
                            </BootstrapTable>
                        </Pagination>
                    );
                }}
            </PaginationProvider>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Hapus Program</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Apakah Anda Yakin Akan Menghapus Program <span className="text-danger font-weight-bold">{toDelete.name}</span> ?
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="submit"
                        className='btn btn-danger ml-2 float-right'
                        onClick={() => deleteProgram()}
                    >
                        Hapus
                    </button>
                    <button
                        type="submit"
                        className="btn btn-warning ml-2 float-right"
                        onClick={handleClose}
                    >
                        Kembali
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ProgramTable;
